import { render, staticRenderFns } from "./ConfirmationViewComponent.vue?vue&type=template&id=5d5f08c6"
import script from "./ConfirmationViewComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmationViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports